import * as React from 'react';
import { put, call, takeLatest, select } from "redux-saga/effects";
import * as Api from "../Diaries/api";
import * as ActionConstants from "./actions/actionConstants";
import { SHOW_LOADER, HIDE_LOADER } from '../../common/actionConstants';
import { SHOW_TOOLTIP } from '../../components/Tooltip/constants';
import { TOOLTIP_DELAY_TIME } from '../SpockViewPage/constants';
import DiaryInfo from '../Diaries/CalenderView/DiaryInfo';
import { detailMapping } from "./reducers/listing";
import { LOG_APPLICATON_ERROR} from "../..//containers/WorkkardDetail/actions/actionConstants";
import { logout } from '../WorkkardDetail/Saga/common';
import {  ErrorCode } from '../..//containers/WorkkardDetail/constants';
import moment from 'moment';
import {  getAxiosError} from "../../common/util";

const hourFormat = "hh A";

function* getToDoList({ payload }) {
    const {isGlobalLoader, isUpdate, isMobileView, ...apiPayload} = payload;
    
    try {
        if (isGlobalLoader) yield put({ type: SHOW_LOADER });

        yield put({ type: ActionConstants.SHOW_LEFT_LISTING_LOADER, payload: true });

        const response = yield call(Api.getToDoList, ActionConstants.GET_DIARIES_LIST_DATA, apiPayload);
        if (response.status === 200) {
            const successType = isUpdate
                ? ActionConstants.UPDATE_TODO_LIST_DATA_SUCCESS
                : ActionConstants.GET_TODO_LIST_DATA_SUCCESS;

            yield put({
                type: successType,
                payload: {response},
            });
        }
    } catch (error) {
        console.error("Geting error in getToDoList saga:", error);
    } finally {
        if (isGlobalLoader) yield put({ type: HIDE_LOADER });
        yield put({ type: ActionConstants.HIDE_LEFT_LISTING_LOADER, payload: false });
    }
}

function* getTodoWeekData(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(Api.getTodoWeekData, ActionConstants.GET_TODO_WEEK_DATA, action.payload);
        if (response.status == 200) {
            const obj = {};
            response.data.TodoDayViewResponseData.forEach(d => {
                if (obj.hasOwnProperty(d.Key.Day)) {
                    if (obj[d.Key.Day].hasOwnProperty(moment(d.Key.Time,hourFormat).format(hourFormat))) {
                        obj[d.Key.Day][moment(d.Key.Time,hourFormat).format(hourFormat)].push(d.TodoData);
                    } else {
                        obj[d.Key.Day][moment(d.Key.Time,hourFormat).format(hourFormat)] = [d.TodoData];
                    }

                } else {
                    obj[d.Key.Day] = {}
                    obj[d.Key.Day][moment(d.Key.Time,hourFormat).format(hourFormat)] = [d.TodoData]
                }
            })
            yield put({ type: ActionConstants.GET_TODO_VIEW_DATA_SUCCESS,  payload: {data:obj, startdate:action.payload.startdate, endDate:action.payload.endDate} })
        } else {
        }
    } catch (error) {
        console.log(error)
    } finally {
        yield put({ type: HIDE_LOADER });
    }
}

function* getTodoMonthData(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(Api.getTodoMonthData, ActionConstants.GET_TODO_MONTH_DATA, action.payload);
        if (response.status == 200) {
            const obj = {};
            response.data.TodoDayViewResponseData.forEach(d => {
                if (obj.hasOwnProperty(d.Day)) {
                    obj[d.Day].push(d.TodoData);
                } else {
                    obj[d.Day] = d.TodoData
                }
            })
            yield put({ type: ActionConstants.GET_TODO_VIEW_DATA_SUCCESS, payload: {data:obj, startdate:action.payload.startdate, endDate:action.payload.endDate} })
        } else {
        }
    } catch (error) {
        console.log(error)
    } finally {
        yield put({ type: HIDE_LOADER });
    }
}

function* getDiaryLogs(action) {
    try {
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER , payload: true});
        const response = yield call(Api.getDiaryLogs, ActionConstants.GET_DIARY_LOGS, action.payload);
        if (response.status == 200) {
            const getDiariesData = (state) => state.diaries;
            const diariesData = yield select(getDiariesData);
            const view = diariesData.view.view;

            if (view == 'list') {
                yield put({ type: ActionConstants.GET_DIARY_LOGS_SUCCESS, payload: response })
            }
            else {
                yield put({ type: ActionConstants.GET_DIARY_LOGS_DAY_VIEW_SUCCESS, payload: response })
            }
        }
    } catch (error) {
        console.log(error)
    } finally {
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER , payload: false });
    }
}

function* getDiaryDetail(action) {
    try {
        if(action.payload.isGlobalLoader){
            yield put({ type: SHOW_LOADER });
        }
        delete action.payload.isGlobalLoader;
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER, payload: true });
        const response = yield call(Api.getDiaryDetail, ActionConstants.GET_DIARY_DETAIL_REQUEST, action.payload);
        if (response.status == 200) {
            yield put({ type: ActionConstants.GET_DIARY_DETAIL_SUCCESS, payload: response.Data })
        } else {
        }
    } catch (error) {
        console.log(error)
    } finally {
        yield put({ type: HIDE_LOADER });
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER , payload: false });
    }
}

function* completeDiary(action) {
    try {        
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER , payload: true});
        const response = yield call(Api.completeToDoDiary, ActionConstants.COMPLETE_DIARY_REQUEST, action.payload);
        // if (status == 200){
        //     const getDiariesData = (state) => state.diaries;
        //     const diariesData = yield select(getDiariesData);
        //     const view = diariesData.view.view;

        //     if(key=="detail"){
        //         yield put({ type: DIARIES_ACTION_COMPLETE_SUCCESS, payload:{id: data.todo_id, isComplete: action.payload.isComplete.toString()} });
        //     }
            
        //     if (view == 'list') {
        //         const activeTab= diariesData.listing.activeTab;
        //         if(activeTab==1){
        //             const logsPayload = { id: data.todo_id };
        //             const logsResponse = yield call(Api.getDiaryLogs, ActionConstants.GET_DIARY_LOGS, logsPayload);
        //             if(logsResponse.status==200)
        //                 yield put({ type: ActionConstants.GET_DIARY_LOGS_SUCCESS, payload: logsResponse });
        //         }
        //         yield put({ type: ActionConstants.COMPLETE_DIARY_SUCCESS_LISTING, payload: { id: data.todo_id, isComplete: action.payload.isComplete, key: key, completedDate: completedDate } })
        //     }
        //     else {
        //         const activeTab= diariesData.view.diaryInfo.activeTab;
        //         if(activeTab==1){
        //             const logsPayload = { id: data.todo_id };
        //             const logsResponse = yield call(Api.getDiaryLogs, ActionConstants.GET_DIARY_LOGS, logsPayload);
        //             if(logsResponse.status==200)
        //                 yield put({ type: ActionConstants.GET_DIARY_LOGS_DAY_VIEW_SUCCESS, payload: logsResponse });
        //         }
        //         yield put({ type: ActionConstants.COMPLETE_DIARY_SUCCESS_VIEW, payload: { id: data.todo_id, isComplete: action.payload.isComplete, key: key, completedDate: completedDate } })
        //     }
        // } else {
        // }
    } catch (error) {
        console.log(getAxiosError(error).error);
    } finally {
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER , payload: false});
    }
};

function* cancelDiary(action) {
    try {
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER , payload: true});
        const { key="" } = action.payload;
        delete action.payload.key;
        
        const response = yield call(Api.cancelToDoDiary, ActionConstants.CANCEL_DIARY_REQUEST, action.payload);
        
        // if (status == 200) {
        //     const getDiariesData = (state) => state.diaries;
        //     const diariesData = yield select(getDiariesData);
        //     const view = diariesData.view.view;

        //     if (view == 'list') {
        //         const activeTab= diariesData.listing.activeTab;
        //         if(activeTab==1){
        //             const logsPayload = { id: action.payload.id };
        //             const logsResponse = yield call(Api.getDiaryLogs, ActionConstants.GET_DIARY_LOGS, logsPayload);
        //             if(logsResponse.status==200)
        //                 yield put({ type: ActionConstants.GET_DIARY_LOGS_SUCCESS, payload: logsResponse });
        //         }
        //         yield put({ type: ActionConstants.CANCEL_DIARY_SUCCESS_LISTING, payload: { id: action.payload.id } })
        //     }
        //     else {
        //         const activeTab= diariesData.view.diaryInfo.activeTab;
        //         if(activeTab==1){
        //             const logsPayload = { id: action.payload.id };
        //             const logsResponse = yield call(Api.getDiaryLogs, ActionConstants.GET_DIARY_LOGS, logsPayload);
        //             if(logsResponse.status==200)
        //                 yield put({ type: ActionConstants.GET_DIARY_LOGS_DAY_VIEW_SUCCESS, payload: logsResponse });
        //         }
        //         yield put({ type: ActionConstants.CANCEL_DIARY_SUCCESS_VIEW, payload: { id: action.payload.id, key: key} })
        //     }
        // } else {
        // }
    } catch (error) {
        console.log(getAxiosError(error).error);
        
    } finally {
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER ,payload: false });
    }
};

function* fetchDiaryInfo(action) {
    try {
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER , payload: true});
        const { target, id, key,position,isErrorScreen } = action.payload;
        const response = yield call(Api.fetchDiaryInfoApi, ActionConstants.FETCH_DIARY_INFO, { id: id });
        if (response.status == 200) {
            let data;
            if (target) {
                data= detailMapping(response.data,true)
                yield put({
                    type: SHOW_TOOLTIP,
                    payload: {
                        delay: TOOLTIP_DELAY_TIME,
                        target,
                        position,
                        toolTipClassName: 'diaryCalendar',
                        hideOnDocClick: false,
                        childComponent: <DiaryInfo data={data} dataKey={key} isTooltip={true} />,
                    }
                });
            }
            else {
                data= detailMapping(response.data,false)
                yield put({ type: ActionConstants.FETCH_DIARY_INFO_SUCCESS, payload: data });
            }
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status:404, isErrorScreen:isErrorScreen }
            });
        }
    }
    catch (error) {
        console.log(error)
    } finally {
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER ,payload: false });
    }
}

function* updateCaptionTodo(action){
    try {
        yield put({ type: ActionConstants.SHOW_RIGHT_LISTING_LOADER , payload: true });
        const response = yield call(Api.updateCaptionTodoApi, ActionConstants.UPDATE_CAPTION_TODO_REQUEST, action.payload);
        if (response.status == 200) {            
            const getDiariesData = (state) => state.diaries;
            const diariesData = yield select(getDiariesData);
            const view = diariesData.view.view;
            if (view == 'list') {
                yield put({ type: ActionConstants.UPDATE_CAPTION_TODOLIST_SUCCESS, payload: {id:action.payload.cid ,caption:action.payload.caption} })
            }
            else{
                yield put({ type: ActionConstants.UPDATE_CAPTION_TODOVIEW_SUCCESS, payload: {id:action.payload.cid ,caption:action.payload.caption} })
            }
        }
    }
    catch (error) {
        console.log(error)
    } finally {
        yield put({ type: ActionConstants.HIDE_RIGHT_LISTING_LOADER , payload: false});
    }
}

export default [
    takeLatest(ActionConstants.GET_DIARIES_LIST_DATA, getToDoList),
    takeLatest(ActionConstants.GET_TODO_WEEK_DATA, getTodoWeekData),
    takeLatest(ActionConstants.GET_TODO_MONTH_DATA, getTodoMonthData),
    takeLatest(ActionConstants.GET_DIARY_LOGS, getDiaryLogs),
    takeLatest(ActionConstants.GET_DIARY_DETAIL_REQUEST, getDiaryDetail),
    takeLatest(ActionConstants.COMPLETE_DIARY_REQUEST, completeDiary),
    takeLatest(ActionConstants.CANCEL_DIARY_REQUEST, cancelDiary),
    takeLatest(ActionConstants.FETCH_DIARY_INFO, fetchDiaryInfo),
    takeLatest(ActionConstants.UPDATE_CAPTION_TODO_REQUEST, updateCaptionTodo)
];